import { GeminiClient } from "./base/GeminiClient";
import { PromptBuilders } from "./utils/PromptBuilders";
import { ResponseParsers } from "./utils/ResponseParsers";
import type {
  ExpandDescriptionRequest,
  ExpandDescriptionResponse,
} from "@/features/Projects";

export class ProjectDescriptionService extends GeminiClient {
  async expandProjectDescription(
    request: ExpandDescriptionRequest
  ): Promise<ExpandDescriptionResponse> {
    if (!request.initialDescription?.trim()) {
      throw new Error("Descrição inicial é obrigatória");
    }

    try {
      const prompt = PromptBuilders.buildExpandDescriptionPrompt(
        request.initialDescription
      );
      const response = await this.callGeminiAPI(prompt);

      return ResponseParsers.parseExpandDescriptionResponse(response);
    } catch (error) {
      console.error("Erro ao expandir descrição:", error);
      throw new Error("Falha ao processar descrição com IA");
    }
  }

  async generateObjectives(projectDescription: string): Promise<string[]> {
    if (!projectDescription?.trim()) {
      throw new Error("Descrição do projeto é obrigatória");
    }

    try {
      const prompt = PromptBuilders.buildObjectivesPrompt(projectDescription);
      const response = await this.callGeminiAPI(prompt);

      return ResponseParsers.parseObjectivesResponse(response);
    } catch (error) {
      console.error("Erro ao gerar objetivos:", error);
      throw new Error("Falha ao gerar objetivos do projeto");
    }
  }
}